(() => {
  if (window.cbRegularFrameHelpReady) return;
  window.cbRegularFrameHelpReady = true;
  const triggers = new WeakMap();
  document.addEventListener('pointerdown', (event) => {
    const control = event.target.closest('[data-cb-frame-open], .cb-regular-frame-dialog');
    if (control) control.dataset.inputMode = 'pointer';
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' && !event.key.startsWith('Arrow')) return;
    document.querySelectorAll('[data-cb-frame-open], .cb-regular-frame-dialog').forEach(control => {
      control.dataset.inputMode = 'keyboard';
    });
  }, true);
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cb-frame-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.cbFrameOpen);
      if (!dialog || dialog.open) return;
      const mode = event.detail === 0 ? 'keyboard' : 'pointer';
      trigger.dataset.inputMode = mode;
      dialog.dataset.inputMode = mode;
      triggers.set(dialog, trigger);
      dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-cb-frame-close]');
    if (close) {
      close.closest('dialog').close();
      return;
    }
    if (event.target.matches('.cb-regular-frame-dialog[open]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches('.cb-regular-frame-dialog')) {
      const trigger = triggers.get(event.target);
      if (trigger?.isConnected) {
        trigger.dataset.inputMode = event.target.dataset.inputMode;
        trigger.focus({ preventScroll: true });
      }
    }
  }, true);
})();
